module.exports = __webpack_public_path__ + "img/pijltje-rechts-wit.92897d31973c979c4b14ded77b2d0fd9.svg";